import React from 'react'

export type BreadcrumbContext = {
  currentPath: string
  labelName: string
  newLabel: string
  indexDuplicated: number | null
  indexToRemove: number | null
  currentIndex: number
  items: BreadcrumbItem
}

export type BreadcrumbItem = {
  index: number
  path: string
  label: string
  next?: BreadcrumbItem | null
  previous?: BreadcrumbItem | null
}

export const breadcrumbContext: BreadcrumbContext = {
  currentPath: '',
  labelName: '',
  newLabel: '',
  indexDuplicated: null,
  indexToRemove: null,
  currentIndex: 0,
  items: { index: 0, path: '/', label: 'Home' }
}

export const DataBreadcrumb = React.createContext(breadcrumbContext)
